import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { useAudience } from "@/hooks/useAudience";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { audience, setAudience } = useAudience();

  const linkBase = "font-medium transition-colors text-base";
  const activeCls = "text-foreground font-semibold";
  const inactiveCls = "text-muted-foreground hover:text-foreground";

  const handleAudience = (next: "owner" | "broker") => {
    setAudience(next);
    if (typeof window !== "undefined") window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 glass border-b border-border/60">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Logo size="md" wordmarkOnly />

          <div className="hidden md:flex items-center gap-8">
            <button onClick={() => handleAudience("owner")} className={`${linkBase} ${audience === "owner" ? activeCls : inactiveCls}`}>
              Para Proprietários
            </button>
            <button onClick={() => handleAudience("broker")} className={`${linkBase} ${audience === "broker" ? activeCls : inactiveCls}`}>
              Para Corretores
            </button>
            <a href="#destaques" className={`${linkBase} ${inactiveCls}`}>Imóveis</a>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link to="/login"><Button variant="ghost" size="sm">Entrar</Button></Link>
            <Link to={audience === "broker" ? "/signup?role=broker" : "/signup"}>
              <Button size="sm" className="bg-gradient-brand text-white hover:opacity-90 shadow-card">
                {audience === "broker" ? "Cadastrar como corretor" : "Cadastrar imóvel"}
              </Button>
            </Link>
          </div>

          <button
            className="md:hidden text-foreground"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="md:hidden bg-background border-b border-border overflow-hidden"
          >
            <div className="px-4 py-4 flex flex-col gap-3">
              <button
                onClick={() => { handleAudience("owner"); setIsOpen(false); }}
                className={`text-sm py-2 text-left ${audience === "owner" ? activeCls : inactiveCls}`}
              >
                Para Proprietários
              </button>
              <button
                onClick={() => { handleAudience("broker"); setIsOpen(false); }}
                className={`text-sm py-2 text-left ${audience === "broker" ? activeCls : inactiveCls}`}
              >
                Para Corretores
              </button>
              <a href="#destaques" className="text-sm font-medium py-2 text-muted-foreground">Imóveis</a>
              <Link to="/login" className="text-sm font-medium py-2 text-muted-foreground">Entrar</Link>
              <Link to={audience === "broker" ? "/signup?role=broker" : "/signup"}>
                <Button size="sm" className="mt-2 w-full bg-gradient-brand text-white hover:opacity-90">
                  {audience === "broker" ? "Cadastrar como corretor" : "Cadastrar imóvel"}
                </Button>
              </Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;
